import { render, staticRenderFns } from "./indexEffect.vue?vue&type=template&id=20c4aebf"
import script from "./indexEffect.vue?vue&type=script&lang=js"
export * from "./indexEffect.vue?vue&type=script&lang=js"
import style0 from "./indexEffect.vue?vue&type=style&index=0&id=20c4aebf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports